import { useState } from "react";
import { useContacts } from "../../api/grpc/contacts/useContacts";
import { useCalendarContext } from "../context/Calendar/CalendarContext";
import {
  People,
  SearchGGContactsRequest,
  SearchIntegrationContactsRequest,
} from "../../api/grpc/contacts/contacts";

export type SearchGGContactsFunction = (
  request: SearchGGContactsRequest
) => Promise<{ response: People }>;

export type SearchIntegrationContactsFunction = (
  request: SearchIntegrationContactsRequest
) => Promise<{ response: People }>;

export function useDirectorySearch() {
  const [searching, setSearching] = useState<string | null>(null);
  const [searchError, setSearchError] = useState<any>(null);
  const [searchResults, setSearchResults] = useState<People | undefined>();
  const { searchGGContacts, searchIntegrationContacts } = useContacts();
  const { personalCalendar } = useCalendarContext();

  const handleDirectorySearch = async (searchQuery: string) => {
    try {
      setSearching("Loading...");
      setSearchError(null);

      const { response } = await searchGGContacts({
        customerID: "",
        query: searchQuery,
        accountID: "",
      });

      setSearchResults(response);
    } catch (err) {
      setSearchError(err);
    } finally {
      setSearching(null);
    }
  };

  const handleIntegrationSearch = async (searchQuery: string) => {
    try {
      if (!personalCalendar?.length) {
        return;
      }

      setSearching("Searching directory...");
      setSearchError(null);

      const { response } = await searchIntegrationContacts({
        customerID: "",
        query: searchQuery,
        accountID: "",
        providerID: personalCalendar[0].iD,
      });

      setSearchResults(response);
    } catch (err) {
      console.error("Error searching integration contacts:", err);
      setSearchError(err);
    } finally {
      setSearching(null);
    }
  };

  return {
    searching,
    searchError,
    searchResults,
    handleDirectorySearch,
    handleIntegrationSearch,
    setSearchResults,
  };
}
